import { ExclamationTriangleIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

interface SuccessBannerProps {
    message: string;
}

function SuccessBanner({ message }: SuccessBannerProps) {
    return (
        <div className="flex items-start gap-3 bg-[#CAF2ED] border border-[#5CC6BB] text-[#2C6F67] rounded-xl px-4 py-3 mb-4">
            <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" />
            <span className="text-sm font-medium">{message}</span>
        </div>
    );
}

interface ErrorBannerProps {
    message: string;
    onRetry?: () => void;
}

function ErrorBanner({ message, onRetry }: ErrorBannerProps) {
    return (
        <div className="flex items-start gap-3 bg-red-50 border border-red-300 text-red-800 rounded-xl px-4 py-3 mb-4">
            <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" />
            <div className="flex flex-col gap-1 text-sm">
                <span>{message}</span>
                {onRetry && (
                    <button
                        onClick={onRetry}
                        className="text-red-700 underline font-medium text-left hover:text-red-900 w-fit"
                    >
                        Try again
                    </button>
                )}
            </div>
        </div>
    );
}

interface BlockedBannerProps {
    /** Omitted where there is no create-DM screen to go back to. */
    onBack?: () => void;
}

function BlockedNotLinkedBanner({ onBack }: BlockedBannerProps) {
    return (
        <div className="flex items-start gap-3 bg-yellow-50 border border-yellow-300 text-yellow-700 rounded-xl px-4 py-3 mb-4">
            <ExclamationTriangleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" />
            <div className="flex flex-col gap-2 text-sm">
                <span className="font-semibold">Patient not linked to Dental Monitoring</span>
                <span>
                    This action requires the patient to have a DM account. Create one first.
                </span>
                {onBack && (
                    <button
                        onClick={onBack}
                        className="text-yellow-700 underline font-medium text-left hover:text-yellow-900 w-fit"
                    >
                        Go back to create a DM patient
                    </button>
                )}
            </div>
        </div>
    );
}

interface InfoBannerProps {
    message: string;
}

function InfoBanner({ message }: InfoBannerProps) {
    return (
        <div className="flex items-start gap-3 bg-yellow-50 border border-yellow-300 text-yellow-700 rounded-xl px-4 py-3 mb-4">
            <ExclamationTriangleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" />
            <span className="text-sm">{message}</span>
        </div>
    );
}

export { SuccessBanner, ErrorBanner, BlockedNotLinkedBanner, InfoBanner };
